function deepClone(obj) {
  if (obj === null || typeof obj !== "object") {
    return obj;
  }

  if (Array?.isArray(obj)) {
    return obj?.map(deepClone);
  }

  const clonedObj = {};
  for (const key in obj) {
    if (obj?.hasOwnProperty(key)) {
      clonedObj[key] = deepClone(obj[key]);
    }
  }
  return clonedObj;
}

export function mergePendingIntoOriginal(originalData, pendingData) {
  if (!originalData || !pendingData || !originalData?.questions || !pendingData?.questions) {
    return originalData;
  }

  const clonedOriginalData = deepClone(originalData);
  const pendingQuestionsMap = new Map();
  pendingData?.questions?.forEach((question) => {
    pendingQuestionsMap?.set(question?.id, question);
  });

  clonedOriginalData?.questions?.forEach((originalQuestion) => {
    const pendingQuestion = pendingQuestionsMap?.get(originalQuestion?.id);

    if (pendingQuestion) {
      // Ensure answers exist
      if (originalQuestion?.answers === null || originalQuestion?.answers === undefined) {
        originalQuestion.answers = {}; // Initialize if not present
      }

      // Handle answers for main questions
      if (originalQuestion?.answers) {
        // Set previousAnswer to null if it's undefined
        originalQuestion.answers.previousAnswer = originalQuestion?.answers?.answer === undefined ? null : originalQuestion?.answers?.answer;

        if (pendingQuestion?.answers && pendingQuestion?.answers?.answer !== undefined) {
          originalQuestion.answers.answer = pendingQuestion?.answers?.answer;
        } else if (pendingQuestion?.answers === null) {
          originalQuestion.answers.answer = null;
        }
      }

      // If both answer and previousAnswer are null, set answers to null
      if (originalQuestion?.answers?.answer === null && originalQuestion?.answers?.previousAnswer === null) {
        originalQuestion.answers = null;
      }

      // Handle options and sub-questions for checkbox type questions (fieldType: 2)
      if (originalQuestion?.options && originalQuestion?.options?.length > 0) {
        const pendingAnswerForCheckbox = pendingQuestion?.answers ? pendingQuestion?.answers?.answer : null;
        const pendingOptionsMap = new Map();
        if (pendingQuestion?.options) {
          pendingQuestion?.options?.forEach((option) => {
            pendingOptionsMap?.set(option?.id, option);
          });
        }

        originalQuestion?.options?.forEach((originalOption) => {
          const pendingOption = pendingOptionsMap?.get(originalOption?.id);
          const isOptionSelected = pendingAnswerForCheckbox === originalOption?.name;

          if (isOptionSelected) {
            const pendingSubQuestionsMap = new Map();
            if (pendingOption && pendingOption?.subQuestion) {
              pendingOption?.subQuestion?.forEach((subQ) => {
                pendingSubQuestionsMap?.set(subQ?.id, subQ);
              });
            }

            if (originalOption?.subQuestion) {
              originalOption?.subQuestion?.forEach((originalSubQuestion) => {
                const pendingSubQuestion = pendingSubQuestionsMap?.get(originalSubQuestion?.id);
                if (pendingSubQuestion) {
                  if (originalSubQuestion?.answers === null || originalSubQuestion?.answers === undefined) {
                    originalSubQuestion.answers = {}; // Initialize if null/undefined
                  }

                  if (originalSubQuestion?.answers) {
                    // Set previousAnswer to null if it's undefined
                    originalSubQuestion.answers.previousAnswer = originalSubQuestion?.answers?.answer === undefined ? null : originalSubQuestion?.answers?.answer;
                  }

                  if (pendingSubQuestion?.answers && pendingSubQuestion?.answers?.answer !== undefined) {
                    originalSubQuestion.answers.answer = pendingSubQuestion?.answers?.answer || null;
                  } else if (pendingSubQuestion?.answers === null) {
                    originalSubQuestion.answers.answer = null;
                  }
                }
              });
            }
          } else {
            if (originalOption?.subQuestion) {
              originalOption?.subQuestion?.forEach((originalSubQuestion) => {
                if (originalSubQuestion?.answers) {
                  originalSubQuestion.answers = {
                    ...originalSubQuestion?.answers,
                    previousAnswer: originalSubQuestion?.answers?.answer,
                    answer: null,
                  };
                } else if (!originalSubQuestion?.answers) {
                  originalSubQuestion.answers = { answer: null };
                }
              });
            }
          }
        });
      }
    }
  });

  return clonedOriginalData;
}
